import { h, Fragment } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'

import { TuileArgument } from '../tuile-argument/tuile-argument.jsx'
import { TuileAiguillage } from '../tuile-aiguillage/tuile-aiguillage.jsx'
import { TuileServicielle } from '../tuile-servicielle/tuile-servicielle.jsx'
import { TuileOffre } from '../tuile-offre/tuile-offre.jsx'
import { TuileDevice } from '../tuile-device/tuile-device.jsx'

// Swiper JS
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const getPriceSize = (items) => {
   for (const { items: tabItems } of items) {
      for (const { template, price } of tabItems) {
         if (template === 'device' && price.length > 6) {
            return true
         }
      }
   }
   return false
}

export const Vitrine = ({ items }) => {
   const [selectedTab, setSelectedTab] = useState(items[0])
   let swiper
   // Gestion de l'accessibilité au tab et aux touches flèches
   const listRef = useRef(null)
   const priceSmall = getPriceSize(items)

   useEffect(() => {
      const listElement = listRef.current
      if (listElement !== null) {
         listElement.querySelectorAll("[role='tab'] button").forEach((tab, index, tabs) => {
            tab.addEventListener('keydown', (e) => {
               let newIndex
               if (e.key === 'ArrowRight') {
                  newIndex = (index + 1) % tabs.length
               } else if (e.key === 'ArrowLeft') {
                  newIndex = (index - 1 + tabs.length) % tabs.length
               }
               if (newIndex !== undefined) {
                  tabs[newIndex].focus()
                  tabs[newIndex].click()
               }
            })
         })
      }

      swiper = new Swiper('.swiper', {
         modules: [Navigation, Pagination],
         navigation: {
            enabled: false,
            nextEl: '.swiper-button-aloha-next',
            prevEl: '.swiper-button-aloha-prev',
         },
         pagination: {
            enabled: true,
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'swiper-pagination-aloha',
            bulletActiveClass: 'swiper-pagination-aloha-active',
            horizontalClass: 'swiper-pagination-aloha-horizontal',
            renderBullet: function (index, className) {
               return '<span class="' + className + '"><span></span></span>'
            },
         },
         direction: 'horizontal',
         loop: false,
         slidesOffsetBefore: 15,
         slidesOffsetAfter: 15,
         spaceBetween: 30,
         slidesPerView: 'auto',
         breakpoints: {
            // when window width is >= 736px
            736: {
               pagination: {
                  enabled: true,
               },
               navigation: {
                  enabled: true,
               },
               slidesOffsetBefore: 30,
            },
            // when window width is >= 960px
            960: {
               navigation: {
                  enabled: false,
               },
               pagination: {
                  enabled: false,
               },
               slidesOffsetBefore: 0,
            },
         },
      })
   }, [])

   return (
      <div class="component-vitrine pb-2 pt-1 bg-gray2">
         <div class="container-fluid">
            <nav class="tabs-menu ob1-menu-page ob1-menu-page-center mb-1">
               <ul class="nav o-nav-light" ref={listRef} role="tablist">
                  {items.map((tab, index) => (
                     <li
                        key={index}
                        role="tab"
                        aria-controls={`vitrine-tab${index}-content`}
                        aria-selected={tab === selectedTab ? 'true' : 'false'}
                        class={`nav-item ${tab === selectedTab ? 'active' : ''}`}
                     >
                        <button onClick={() => setSelectedTab(tab)} class="nav-link" id={`vitrine-tab${index}`} tabIndex={tab === selectedTab ? '0' : '-1'}>
                           {tab.title}
                        </button>
                     </li>
                  ))}
               </ul>
            </nav>
         </div>
         <div class="tabs-container">
            {items.map((tab, index) => (
               <Fragment key={index}>
                  <div class="container-fluid d-flex justify-content-between">
                     <h3 class="tab-title mb-0 mt-0">{tab.title}</h3>
                     {tab.lien_aiguillage && (
                        <a
                           href={tab.lien_aiguillage.URL}
                           class="o-link-arrow d-lg-none"
                           data-pdb-zid={tab.lien_aiguillage.analytics.pdbZid}
                           data-pdb-sc={tab.lien_aiguillage.analytics.pdbSc}
                           data-pdb-idc={tab.lien_aiguillage.analytics.pdbIdc}
                           data-pdb-vi={tab.lien_aiguillage.analytics.pdbVi}
                           data-oevent-category={tab.lien_aiguillage.analytics.oeventCategory}
                           data-oevent-action={tab.lien_aiguillage.analytics.oeventAction}
                           data-oevent-label={tab.lien_aiguillage.analytics.oeventLabel}
                           data-oevent-other={tab.lien_aiguillage.analytics.oeventOther}
                        >
                           {tab.lien_aiguillage.label}
                        </a>
                     )}
                  </div>
                  <div class="container-fluid only-after-960">
                     <div class={`tab-content ${tab === selectedTab ? 'active' : ''}`} role="tabpanel" id={`vitrine-tab${index}-content`} aria-labelledby={`vitrine-tab${index}`}>
                        <div class="swiper">
                           <div class="swiper-wrapper">
                              {tab.items.map((tile, index) => (
                                 <div key={index} class={`swiper-slide tile tile${index + 1} ${index === 0 || index === 5 ? 'double' : 'simple'}`}>
                                    {renderTile(tile, priceSmall)}
                                 </div>
                              ))}
                           </div>

                           <div class="swiper-pagination"></div>

                           <div class="swiper-button-aloha swiper-button-aloha-prev">
                              <span class="icon-arrow-previous" aria-hidden="true"></span>
                           </div>
                           <div class="swiper-button-aloha swiper-button-aloha-next">
                              <span class="icon-arrow-next" aria-hidden="true"></span>
                           </div>
                        </div>
                     </div>
                  </div>
               </Fragment>
            ))}
         </div>
      </div>
   )
}

const renderTile = (props, priceSmall) => {
   const { template, ...restOfProps } = props

   if (template === 'device') {
      restOfProps.price_small = priceSmall
   }
   const components = {
      argument: TuileArgument,
      aiguillage: TuileAiguillage,
      offre: TuileOffre,
      servicielle: TuileServicielle,
      device: TuileDevice,
   }
   const Component = components[template]
   return Component ? <Component {...restOfProps} /> : null
}
